<div class="cont">
  <div class="mainbody">
    <div class="modal__headerspace"> </div>
    <span class="float-to-right">
      <span
        class="close-icon"
        icon="times"
        (click)="activeModal.dismiss()"
      >
        <i class="bi bi-x"></i>
      </span>
    </span>
    <div class="lockimage">
      <img src=" ./assets/forbidden/forbidden.svg" alt="Forbidden SVG" />
    </div>

    <div class="modal__content">
      <h1 class="modal__title">
        {{ "modules.expert-tool.result.log.modal.subtite-1" | transloco }}
      </h1>

    </div>
  </div>
</div>
